import { CascaderOptionType } from 'antd/lib/cascader'
import { cascaderOptionsHaveNestedLevel } from '../../../components/custom_components/Cascader/util'

/** Company-settings Cascader: nested options are countries (not used for BU tabs). */
export const getCompanyCascaderSearchPlaceholder = (t: (key: string) => string, options: CascaderOptionType[]): string =>
  t(
    cascaderOptionsHaveNestedLevel(options)
      ? 'companySettingsView.companyOrCountryCascaderSearchPlaceholder'
      : 'companySettingsView.companyCascaderSearchPlaceholder',
  )
